<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import http from '@/api/http'
import Button from 'primevue/button'
import Select from 'primevue/select'
import Message from 'primevue/message'
import FileUpload from 'primevue/fileupload'

const router = useRouter()

const type = ref('rfm')
const file = ref(null)
const submitting = ref(false)
const error = ref('')
const success = ref(null)

const typeOptions = [
  { label: 'Росфинмониторинг', value: 'rfm' },
  { label: 'СБ ООН', value: 'un_sc' },
  { label: 'МВК', value: 'mvk' },
]

function resolveTypeValue(raw) {
  if (raw == null || raw === '') return 'rfm'
  if (typeof raw === 'object') return String(raw.value ?? 'rfm')
  return String(raw)
}

function onSelect(event) {
  file.value = event.files?.[0] ?? null
  error.value = ''
  success.value = null
}

function clearFile() {
  file.value = null
}

async function submit() {
  error.value = ''
  success.value = null
  if (!file.value) {
    error.value = 'Выберите файл XML'
    return
  }
  submitting.value = true
  try {
    const typeValue = resolveTypeValue(type.value)
    const fd = new FormData()
    fd.append('type', typeValue)
    fd.append('file', file.value)
    // type дублируем в query — не зависит от разбора multipart-тела на сервере
    const { data } = await http.post('/scrolls', fd, {
      params: { type: typeValue },
      timeout: 600_000,
    })
    success.value = data?.data ?? data
    file.value = null
  } catch (e) {
    error.value = e?.response?.data?.error?.message || 'Ошибка загрузки'
  } finally {
    submitting.value = false
  }
}
</script>

<template>
  <div class="page upload">
    <div class="card">
      <div class="row">
        <label>Тип перечня</label>
        <Select
          v-model="type"
          :options="typeOptions"
          option-label="label"
          option-value="value"
        />
      </div>

      <div class="row">
        <label>XML-файл</label>
        <FileUpload
          name="file"
          mode="basic"
          accept=".xml,application/xml,text/xml"
          choose-label="Выбрать файл"
          :auto="false"
          :custom-upload="true"
          @select="onSelect"
        />
        <p v-if="file" class="muted">
          {{ file.name }} — {{ (file.size / 1024 / 1024).toFixed(2) }} МБ
          <Button
            text
            severity="secondary"
            icon="pi pi-times"
            label="убрать"
            size="small"
            @click="clearFile"
          />
        </p>
      </div>

      <Message v-if="error" severity="error" :closable="false">{{ error }}</Message>

      <Message v-if="success" severity="success" :closable="false">
        Файл принят. job_id:
        <code>{{ success.job_id ?? success.id ?? '—' }}</code>
      </Message>

      <div class="actions">
        <Button
          label="К списку"
          severity="secondary"
          outlined
          icon="pi pi-arrow-left"
          @click="router.push({ name: 'scrolls' })"
        />
        <Button
          label="Загрузить"
          icon="pi pi-upload"
          :loading="submitting"
          :disabled="!file"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.upload .card {
  background: #fff;
  border: 1px solid var(--p-surface-200, #e5e7eb);
  border-radius: 0.5rem;
  padding: 1.25rem;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.row > label {
  font-size: 0.85rem;
  color: #4b5563;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
</style>
